module.exports = __webpack_public_path__ + "04bc5d5c57ad358df4b341d73c0bee10.pdf";